module.exports = __webpack_public_path__ + "img/modelo_duna.dcb89180.png";